import { DEV } from "solid-js"
import type { Object3D } from "three"
import removeItem from "../../../array/remove_item"
import type { Engine } from "../../../core/engine/Engine.type"
import Unexpected from "../../../Exception/Unexpected.class"

export type GameObject3DFrameEventFunction = (dt: number, at: number) => void

// let GameObject3DFrameUpdateObjectsCount = 0
// let shouldLog = false

// setInterval(() => {
//   shouldLog = true
// }, 5000)

const GameObject3DFrameUpdateObjectsWarningThresshold = 512

export function dispatchGameObject3DFrameEvent(
  list: ReadonlyArray<GameObject3DFrameEventFunction>,
  dt: number,
  at: number,
): void {
  // const list = engine.ofELL()
  // console.log('dispatchGameObject3DFrameEvent.list', list)

  // if (shouldLog) {
  //   shouldLog = false
  //   console.log('dispatchGameObject3DFrameEvent', {
  //     count: GameObject3DFrameUpdateObjectsCount,
  //     list: list.length,
  //   })
  // }

  if (DEV) {
    if (list.length > GameObject3DFrameUpdateObjectsWarningThresshold && !(window as unknown as Record<string, boolean>).frameListThresholdExceeded) {
      (window as unknown as Record<string, boolean>).frameListThresholdExceeded = true
      console.warn(`GameObjectsFrameUpdate exceeds threshold ${GameObject3DFrameUpdateObjectsWarningThresshold} (len=${list.length})`)
    }
  }

  // let frameResult : FrameResult | undefined
  for (const fn of list) {
    fn(dt, at)
    // frameResult = fn(dt, at)
    // if (frameResult === FrameResult.REMOVE) {
    //   removeItem(list, fn)
    // }
  }
}

export function mountOnFrameUpdateToObject3D(
  engine: Engine,
  obj: Object3D,
  fn: GameObject3DFrameEventFunction,
): void {
  const list = engine.ofELL()

  if (DEV) {
    if (!obj) {
      throw new Unexpected('!obj')
    }
  }

  // console.log('mountOnFrameUpdate.set', set)
  if (DEV) {
    if (list.includes(fn)) {
      console.log('mountOnFrameUpdate.list.includes(fn)', engine, obj, fn)
      throw new Unexpected('list.includes(fn)')
    }
  }
  list.push(fn)
  // GameObject3DFrameUpdateObjectsCount++
  obj.addEventListener('removed', () => {
    removeItem(list, fn)
    // GameObject3DFrameUpdateObjectsCount--
  })
}